<template>
<div class="cateListDialog" v-if="dialogVisible">
    <el-dialog @close='cancel' title="分类管理" :visible.sync="dialogVisible">
        <div class="right_main_box">
            <div class="add_goods_tabs_box">
                <el-table :data="tableData" style="width: 100%" :show-header="false" ref="multipleTable">
                    <el-table-column type="index" width="30"></el-table-column>
                    <el-table-column prop="catename" label="分类名称" class-name="center"></el-table-column>
                    <el-table-column label="操作" width="150" label-class-name="tr">
                        <template slot-scope="scope">
                            <div class="tr">
                        <span class="separator-btn">
                            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
                        </span>
                                <span class="separator-btn">
                            <el-button @click="handleDel(scope.row)" type="text" size="small">删除</el-button>
                        </span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page" style="margin-top: 15px; text-align: center">
                <el-pagination
                    background
                    @current-change="handleSizeChange"
                    :current-page.sync="page.page"
                    :page-size="page.pageSize"
                    :pager-count="11"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
            <div slot="footer" class="dialog-footer" style="margin-top: 20px;">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="handleAdd">新增分类</el-button>
            </div>
        </div>
    </el-dialog>
    <cateDialog ref="cateDialog" @getEventProductCategoryList="_getList"></cateDialog>
</div>
</template>

<script>
import {getEventProductCategoryList, deleteEventProductCategory, getProviderEventProductCategoryList, deleteProviderEventProductCategory} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import CateDialog from 'views/brandBusiness/systemSetting/goodsBack/components/cateDialog.vue'
export default {
    name: 'cateListDialog',
    data() {
        return {
            param: {
                name: ''
            },
            page: {
                page: 1,
                pageSize: 8,
                pageCount: 0
            },
            total: 0,
            dialogVisible: false,
            tableData: [],
            hostroletype: 2
        }
    },
    mounted() {
    },
    methods: {
        openDialog(hostroletype) {
            this.hostroletype = hostroletype
            this.tableData = []
            this.dialogVisible = true
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        handleEdit(row) {
            this.$refs.cateDialog.openDialog(row, this.hostroletype)
        },
        handleDel(row) {
            this.$confirm('确认删除该分类', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                if (this.hostroletype === 2 || this.hostroletype === '2') {
                    this._del(row)
                } else {
                    this._del2(row)
                }
            })
        },
        handleAdd() {
            let obj = {
                catecode: '',
                catename: ''
            }
            this.$refs.cateDialog.openDialog(obj,  this.hostroletype)
        },
        handleSizeChange() {
            if (this.hostroletype === 2 || this.hostroletype === '2') {
                this._getList()
            } else {
                this._getList2()
            }
        },
        cancel() {
            this.page.page = 1
            this.param.name = ''
            this.dialogVisible = false
        },
        _del(obj) {
            this.setLoading(true)
            deleteEventProductCategory({
                data: Object.assign({}, {catecode: obj.catecode}),
                success: data => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _del2(obj) {
            this.setLoading(true)
            deleteProviderEventProductCategory({
                data: Object.assign({}, {catecode: obj.catecode}),
                success: data => {
                    this.$message.success('删除成功')
                    this.setLoading(false)
                    this._getList2()
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getEventProductCategoryList({
                data: Object.assign({}, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList2() {
            this.setLoading(true)
            getProviderEventProductCategoryList({
                data: Object.assign({}, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user', 'params', 'brandBusiness'])
    },
    components: {
        CateDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.cateListDialog {
    .el-dialog .el-dialog__body{
        padding: 0 20px;
    }
    .el-table__body, .el-table__footer, .el-table__header{
        width: 100% !important;
    }
    .el-dialog .tr .el-button{
        margin-bottom: 0;
        min-width: 48px;
    }
    .el-table td, .el-table th{
        padding: 6px 0;
    }
}
</style>
